export const TOKEN_COOKIE_NAME = '_webchat_widget_token';
export const VIEW_COOKIE_NAME = '_webchat_view';
export const VISITOR_COOKIE_NAME = '_webchat_visitor';
export const VISIT_COOKIE_NAME = '_webchat_visit';
export const DEFAULT_COOKIE_TIME_IN_DAYS = 90;
export const NEVER_EXPIRE = -1;

const cookieCache: Record<string, string> = {};
let parentOrigin = '*';

export function initCookieProxy(cookieString: string, origin: string): void {
  parentOrigin = origin;
  if (!cookieString) return;
  for (const part of cookieString.split(';')) {
    const idx = part.indexOf('=');
    if (idx === -1) continue;
    const name = part.substring(0, idx).trim();
    const value = part.substring(idx + 1).trim();
    cookieCache[name] = value;
  }
}

export function setCookie(cookieName: string, value: string, days: number = DEFAULT_COOKIE_TIME_IN_DAYS): void {
  cookieCache[cookieName] = value;
  window.parent.postMessage({ type: 'webchat:set-cookie', detail: { cookieName, value, days } }, parentOrigin);
}

export function getCookie(cookie_name: string): string {
  return cookieCache[cookie_name] || '';
}
